import { render, staticRenderFns } from "./Responsive.vue?vue&type=template&id=cf02704a&"
import script from "./Responsive.vue?vue&type=script&lang=js&"
export * from "./Responsive.vue?vue&type=script&lang=js&"
import style0 from "./Responsive.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports